<template>
  <div class="page">
    <div class="list-view">
      <p class="title">憬悦管家隐私政策</p>
      <ud-empty-row />
      <p class="info">本隐私信息保护政策更新日期：2021年11月29日</p>
      <p class="info"></p>
      <p class="info">本隐私信息保护政策生效日期：2021年11月29日</p>
      <p class="info"></p>
      <p class="info">若您对本隐私政策条款有任何疑问、意见或建议，您可通过本《隐私政策》第10条"联系我们"中公布的联系方式与我们联系。</p>
      <p class="info"></p>
      <p class="info">版本更新提示</p>
      <p class="info"></p>
      <p class="info">我们于近日更新了《憬悦管家隐私政策》。我们于近日更新了《憬悦管家隐私政策》。本次更新的内容主要包括：调整、新增本隐私政策不适用的情形；调整、新增关键词的涵义；新增我们收集您个人信息的原则与途径；新增我们收集的您在使用服务过程中产生的信息内容；新增我们依法收集您的个人信息的 情形；新增我们共享您的个人信息的部分情形（包括关联公司间的共享）；调整我们依法公开披露您的个人信息的情形；调整我们的用户个人信息保护制度；新增我们对您的个人信息的存储地点与存储期限；调整和优化部分章节结构与条款的表述，使本政策更便于您 的理解。</p>
      <p class="info"></p>
      <p class="info">引言</p>
      <p class="info"></p>
      <p class="info">憬悦管家APP由深圳市景悦科技有限公司（注册地址/常用办公地址：深圳市福田区深南大道6011号NEO企业大厦A座61层）及其关联公司（以下合称"我们"） 提供产品运营和服务。 我们非常注重保护您的个人信息及隐私，我们深知个人信息对您的重要性，并将按照法律法规要求和业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。 我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则等。 依据法律的规定，我们将在特定情形下收集、使用、存储和披露您的个人信息。</p>
      <p class="info"></p>
      <p class="info">本政策与您所使用的我们的产品与/或服务息息相关，您在使用我们的产品与/或服务时，我们将按照本政策的约定处理和保护您的个人信息，因此我们希望您能够仔细阅读、充分理解本政策的全文，并在需要时，按照本政策的指引，作出您认为适当的选择。</p>
      <p class="info"></p>
      <p class="info">在您使用我们的产品与/或服务之前，请您务必仔细阅读、充分理解本政策，涉及本政策中与您的权益（可能）存在重大关系的条款，我们已经以字体加粗、下划线或其他合理方式提示您重点阅读。 您应当在充分阅读、明确理解并同意本政策的全部条款后，开始使用我们的产品与/或服务。如果您不同意本政策的内容，您应立即停止使用我们的产品与/或服务；您使用或继续使用我们提供的产品与/或服务的行为，表示您充分理解和同意本《憬悦管家隐私政策》（包括更新版本）的全部内容。 本政策之中涉及的相关技术词汇，我们尽量以通俗易懂的表述向您解释，以便于您理解。</p>
      <p class="info"></p>
      <p class="info">本政策将帮助您了解以下内容，请根据以下索引阅读相应章节：</p>
      <p class="info"></p>
      <p class="info">1. 本隐私政策的适用范围、关键词涵义</p>
      <p class="info"></p>
      <p class="info">2. 我们如何收集您的个人信息</p>
      <p class="info"></p>
      <p class="info">3. 我们如何使用您的个人信息</p>
      <p class="info"></p>
      <p class="info">4. 我们如何共享、转让、公开披露您的个人信息</p>
      <p class="info"></p>
      <p class="info">5. 我们如何使用Cookie和同类技术</p>
      <p class="info"></p>
      <p class="info">6. 您如何管理个人信息</p>
      <p class="info"></p>
      <p class="info">7. 我们如何存储和保护您的个人信息</p>
      <p class="info"></p>
      <p class="info">8. 未成年人保护</p>
      <p class="info"></p>
      <p class="info">9. 本政策如何更新</p>
      <p class="info"></p>
      <p class="info">10. 联系我们</p>
      <p class="info"></p>
      <p class="info">1. 本隐私政策的适用范围、关键词涵义</p>
      <p class="info">1.1 本隐私政策的适用范围</p>
      <p class="info"></p>
      <p class="info">本隐私政策仅适用于景悦提供的憬悦管家产品与/或服务。在使用憬悦管家各项服务前，请务必仔细阅读并透彻理解本协议，并作出您认为适当的选择。</p>
      <p class="info"></p>
      <p class="info">请您注意，本政策不适用于以下情况：</p>
      <p class="info"></p>
      <p class="info">（1）我们的产品与/或服务中包含的或链接至第三方提供的信息与/或第三方服务（包括任何第三方应用、网站、产品、服务等），这些信息与/或服务由第三方负责运营，您使用该信息与/或服务适用第三方另行向您说明的个人信息收集、使用的规则。</p>
      <p class="info"></p>
      <p class="info">（2）其他非景悦向您提供的产品与/或服务内容。</p>
      <p class="info"></p>
      <p class="info">1.2 关键词涵义</p>
      <p class="info"></p>
      <p class="info">· 憬悦管家：指憬悦管家APP或对憬悦管家APP享有所有权或运营权的主体深圳市景悦科技有限公司及其关联公司。</p>
      <p class="info"></p>
      <p class="info">· 憬悦管家用户：指《憬悦管家用户协议》中定义的憬悦管家用户，即在憬悦管家APP及憬悦管家授权的其他渠道成功注册的个人。</p>
      <p class="info"></p>
      <p class="info">· 个人信息：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。（出自于GB/T 35273-2020《信息安全技术 个人信息安全规范》）。</p>
      <p class="info"></p>
      <p class="info">· 个人敏感信息：指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇的个人信息。（出自于GB/T 35273-2020《信息安全技术 个人信息安全规范》）。</p>
      <p class="info"></p>
      <p class="info">· 儿童：指不满十四周岁的未成年人。（出自于《儿童个人信息网络保护规定》）</p>
      <p class="info"></p>
      <p class="info">· 未成年人：不满十八周岁的自然人为未成年人。十六周岁以上的未成年人，以自己的劳动收入为主要生活来源的，视为完全民事行为能力人。（出自于《中华人民共和国民法典》）</p>
      <p class="info"></p>
      <p class="info">· 设备信息：通常包括设备型号、设备名称、操作系统和应用程序版本、设备MAC地址、国际移动设备识别码（包括IMEI/Android ID/OpenUDID/SIM卡IMSI信息）、唯一设备标识符（包括IDFA/OAID 及其他综合设备各参数形成的设备标识符）、应用列表信息等软硬件特征信息、网络信息（包括运营商名称）、IP地址、设备所在位置相关信息（包括通过GPS信息、WLAN接入点、蓝牙和基站等传感器信息获取到的精确地理位置信息及通过网络位置信息（例如基站、IP及WLAN）获取的大致地理位置信息）。</p>
      <p class="info"></p>
      <p class="info">· 关联公司：在控制深圳市景悦科技有限公司、受深圳市景悦科技有限公司控制或与深圳市景悦科技有限公司处于共同控制下的公司、机构以及前述公司、机构的合法继承人，例如：浙江憬悦管家服务集团有限公司、景悦房地产咨询集团有限公司、浙江圈城网络科技有限公司。控制指通过所有权、有投票权的股份、合同、实际运营关联或其他被依法认定的方式直接或间接地拥有影响被控制对象管理/经营的能力。</p>
      <p class="info"></p>
      <p class="info">2. 我们如何收集您的个人信息</p>
      <p class="info">我们会根据合法正当、最小必要、公开透明的原则，基于本政策所述的目的，收集和使用您的个人信息。 如果我们将您的个人信息用于本政策未载明的其他用途， 或基于其他特定目的而收集和使用您的个人信息，我们将以合理的方式（包括但不限于通过更新本政策、重新签署文件、页面提示、弹窗、站内信、邮件、网站公告或其他便于您获知的方式）另行向您详细说明对应信息的收集、使用目的、方式、范围等规则，在征得您授权同意后收集和使用。</p>
      <p class="info"></p>
      <p class="info">通讯录、地理位置、相机、麦克风、相册等系统权限，均不会默认开启，只有经过您的明示授权才会在为实现特定功能/服务时访问，您可以随时撤回授权。 特别需要指出的是，即使经过您的授权，可以访问您的相应权限，我们仅会在您的授权范围内进行访问；且如您拒绝提供的，仅会使您无法使用相应功能，但并不影响您正常使用产品与/或服务的其他功能。</p>
      <p class="info"></p>
      <p class="info">您理解并同意：</p>
      <p class="info"></p>
      <p class="info">由于我们的产品和服务较多，为您提供的内容也不同，因此收集的您的个人信息类型也会因产品/服务的内容不同而有所区别，具体以产品/服务实际提供为准；我们希望提供给您的产品和服务是完善的，所以我们会不断改进我们的产品和服务，这意味着随着产品和服务的迭代、拓展、升级等，我们可能会经常推出新的业务功能或重新划分业务功能，并可能需要收集新的个人信息或变更个人信息使用目的或方式。</p>
      <p class="info"></p>
      <p class="info">2.1 我们主要通过以下途径收集您的个人信息：</p>
      <p class="info"></p>
      <p class="info">(1) 您在使用我们的产品与/或服务时，根据业务需要您主动提供的信息，例如：注册账号时提供的手机号码。</p>
      <p class="info"></p>
      <p class="info">(2) 您在使用我们的产品与/或服务时，我们收集、记录、汇总的信息，例如：您的设备信息、日志信息。</p>
      <p class="info"></p>
      <p class="info">(3) 您在使用我们的产品与/或服务时，我们从第三方间接获取的您的信息，例如：您公开在其他开放的平台上的信息。</p>
      <p class="info"></p>
      <p class="info">2.2 我们收集您的哪些个人信息</p>
      <p class="info"></p>
      <p class="info">"憬悦管家APP"支持多类操作系统的使用，在您通过各种手机操作系统使用"憬悦管家APP"的过程中，"憬悦管家APP"所收集的信息仅限于您同意使用"憬悦管家APP"基本服务所必需的信息。</p>
      <p class="info"></p>
      <p class="info">通常情况下，我们会出于以下功能/场景实现，收集和使用您的个人信息：</p>
      <p class="info"></p>
      <p class="info">服务项 目的及收集范围</p>
      <p class="info">账号注册与登录 当您注册、登录我们的产品与/或服务时，为了帮您顺利完成注册流程、为您持续稳定提供专属于注册用户的产品与/或服务，您需要向我们提供您的手机号码并进行验证。 如您拒绝提供前述个人信息，则可能无法成功注册憬悦管家账户或使用憬悦管家关联服务，同时我们支持用户账号的注销，可以通过联系管理员进行账号注销说明，由管理人员进行审核后，经过15天审核后会将您的账号内用户信息进行永久性清除。</p>
      <p class="info"></p>
      <p class="info"></p>
      <p class="info">报修报事 您使用报修报事功能时，依据您需要服务的内容，我们会收集您的姓名、房号、报修设备信息、报修时间，以便能够上门为您提供相关服务。如您不提供前述信息，则可能无法使用本功能项下的相关服务，但不影响您使用我们提供的其他服务。</p>
      <p class="info"></p>
      <p class="info">个推推送（消息通知） 您使用消息推送时，我们会收集您的设备信息用于识别唯一用户，保证消息推送的精准送达；</p>
      <p class="info">我们会收集您设备上不同APP的活跃信息，以整合消息推送的通道资源，为开发者提高消息送达率；</p>
      <p class="info">我们会收集您的应用信息（应用崩溃信息、通知开关状态、软件列表相关信息）、设备参数及系统信息（设备类型、设备型号、操作系统及硬件相关信息）、网络信息和位置信息，以优化SDK与个推服务器的网络连接请求，保证服务的稳定性和连续性，并实现区域推送的功能。</p>
      <p class="info"></p>
      <p class="info"></p>
      <p class="info">蓝牙开门 您使用蓝牙开门功能时，我们会收集您的姓名、房号、使用时间、使用次数、开门状态信息、您使用手机开门服务时以及开门成功时的地理位置信息。 您的地理位置信息属于个人敏感信息。如您不提供前述信息，则可能无法使用本功能项下的相关服务，但不影响您使用我们提供的其他服务。</p>
      <p class="info">工单（巡更、巡检、保养、维修、前介、事件上报、督办查等） 您使用工单功能时，我们会收集您的姓名、手机号、工号、岗位、照片、工单状态、工单接单完成时间、所属项目名称信息、您手机的接单地理位置信息、您的相册照片信息。您的地理位置信息和相册照片信息属于个人敏感信息，如您不提供前述信息，则可能无法使用本功能项下的相关服务，但不影响您使用我们提供的其他服务。</p>
      <p class="info"></p>
      <ud-empty-row height="24" />
      <p class="info" id="step_11">附录：憬悦管家第三方SDK目录</p>
      <p class="info">SDK名称：个推</p>
      <p class="info">SDK包名：com.getui.gtc 、com.igexin.sdk</p>
      <p class="info">所属机构名称：每日互动股份有限公司</p>
      <p class="info">SDK用途：UniPush推送</p>
      <p class="info">可能获取的个人信息类型：网络信息、IMEI、openid、应用安装列表</p>
      <p class="info">调用的设备权限：获取网络状态、访问Wi-Fi状态、读取手机状态和身份</p>
      <p class="info">详情请查看官网链接：https://docs.getui.com/privacy/</p>
      <ud-empty-row height="6" />
      <p class="info">SDK名称：HMS push</p>
      <p class="info">SDK包名：com.huawei.hms</p>
      <p class="info">所属机构名称：华为开发者联盟</p>
      <p class="info">SDK用途：华为手机厂商推送</p>
      <p class="info">可能获取的个人信息类型：您的ID、应用ID、应用包名、服务器公网IP地址</p>
      <p class="info">调用的设备权限：获取应用列表信息</p>
      <p class="info">详情请查看官网链接：https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/privacy-statement-0000001050042021</p>
      <ud-empty-row height="6" />
      <p class="info">SDK名称：小米推送</p>
      <p class="info">SDK包名：com.xiaomi.mipush</p>
      <p class="info">所属机构名称：小米科技</p>
      <p class="info">SDK用途：小米手机厂商推送</p>
      <p class="info">可能获取的个人信息类型：您的ID、应用ID、应用包名、服务器公网IP地址</p>
      <p class="info">调用的设备权限：获取应用列表信息</p>
      <p class="info">详情请查看官网链接：https://dev.mi.com/console/doc/detail?pId=1822</p>
      <ud-empty-row height="6" />
      <p class="info">SDK名称：友盟</p>
      <p class="info">SDK包名：com.uc.crashsdk、com.efs、com.umeng</p>
      <p class="info">所属机构名称：友盟同欣（北京）科技有限公司、北京锐讯灵通科技有限公司</p>
      <p class="info">SDK用途：统计</p>
      <p class="info">可能获取的个人信息类型：网络信息、IMEI、openid</p>
      <p class="info">调用的设备权限：获取网络状态、访问Wi-Fi状态、读取手机状态和身份</p>
      <p class="info">详情请查看官网链接：https://www.umeng.com/page/policy</p>
      <ud-empty-row height="6" />
    </div>
  </div>
</template>
<script>
import UdEmptyRow from '@/components/ud-empty-row'

export default {
  components: {
    UdEmptyRow
  }
}
</script>

<style lang="scss" scoped>
.page {
  padding: 24px;
  box-sizing: border-box;
}

.list-view {
  flex: 1;
  @include relative;
}

.title {
  @include text(28px);
  text-align: center;
}

.info {
  margin-bottom: 12px;
  @include text(22px);
  line-height: 1.2;
  @extend .flex-row;
  justify-content: space-between;
}
</style>